import './calendar.scss';
import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { CnCalendar as UICnCalendar } from './calendar';
export var CnCalendar = withI18n(UICnCalendar, { locale: locale });
